module.exports = __webpack_public_path__ + "static/media/low_carbon_detail_zfb.79743738.png";